import { toPriceCurrency } from '@/utils/filters'

export default ({ isPreview }) => ({
  isAutoLoad: false,
  store: {
    get: {
      url: 'RFQ2s/GetAllDynamic',
      selected: [
        'id', 'entryDate', 'supplierCompanyID', 'supplierCompany.name as supplierCompanyName', 'partSN',
        'price', 'currencyID', 'currency.title as currencyTitle', 'conditionID', 'condition.title as conditionTitle',
        'releaseID,release.title as releaseTitle', 'traceabilityCompanyID', 'traceabilityCompany.name as traceabilityCompanyName',
        'tagInfoCompanyID', 'tagInfoCompany.name as tagInfoCompanyName', 'tagDate'
      ],
      filters: 'price != null && price != ""'
    },
    patch: {
      // eslint-disable-next-line no-template-curly-in-string
      url: 'RFQ2s/Patch/${data.id}'
    }
  },
  columns: [
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("supplier")}',
      field: 'supplierCompanyName',
      sortable: {
        custom: 'supplierCompany.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("entry-date")}',
      field: 'entryDate',
      template: 'date'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("part-sn")}',
      field: 'partSN'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("price")}',
      field: 'priceTitle',
      template: (row) => toPriceCurrency(row.price, row.currencyTitle),
      sortable: {
        custom: 'price'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('condition')}",
      field: 'conditionTitle',
      sortable: {
        custom: 'condition.title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("release")}',
      field: 'releaseTitle',
      sortable: {
        custom: 'release.title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("traceability")}',
      field: 'traceabilityCompanyName',
      sortable: {
        custom: 'traceabilityCompany.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("tag-info")}',
      field: 'tagInfoCompanyName',
      sortable: {
        custom: 'tagInfoCompany.name'
      }
    }
  ],
  sortable: {
    field: 'entryDate',
    order: 'desc'
  },
  rowControls: {
    left: {
      controls: isPreview
        ? []
        : [
          {
            type: 'custom',
            // eslint-disable-next-line no-template-curly-in-string
            title: '${root.L10n("add-to-quote")}'
          }
        ]
    }
  },
  header: {
    isVisible: false
  }
})
